import React from 'react'
import { findArray } from 'helpers/utils'
import Label from "components/general/Label"
import { ColumnBib, ColumnName, ColumnNoc } from "components/common/TableColumns"
import { ColumnIntermediateRankOws } from 'components/sports/ows/events/ows_race/results/Columns'
import { createColumnsIntermediate } from 'components/sports/ows/helper/OwsHelpers'

export function ColumnIntermediateTimeDiffOws({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind',
    status = ''
}) {
    return (
        {
            Header: <Label data={label} />,
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'IntermediateDiff',
            Cell: (props) => {
                let row = props.cell.row.original

                let intermediate = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [row.currentSplit] })

                let val = intermediate?.er_value
                let diff = intermediate?.er_diff

                let rank = intermediate?.er_rank

                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value

                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'IRM_TIME')
                        ? photo && status !== true
                            ? ''
                            : rank === '1'
                                ? val
                                : diff
                        : status
                            ? rank === '1'
                                ? val
                                : diff
                            : ''
                )

            },


        }
    )
}

export function TableColumnsLive(columnsAdded) {
    let columnsExt = createColumnsIntermediate(columnsAdded);
    return (
        [
            ColumnIntermediateRankOws({}),
            ColumnBib({ label: "HeaderBibNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ...columnsExt
        ]
    )
}

export function TableColumnsLiveSM() {
    return (
        [
            ColumnIntermediateRankOws({ disableSort:true }),
            ColumnBib({ disableSort:true, label: "HeaderBibNo" }),
            ColumnNoc({}),
            ColumnName({ disableSort:true }),
            ColumnIntermediateTimeDiffOws({ label: "HeaderTime"}),
        ]
    )
}

export function TableColumnsOfficial(columnsAdded,isFinish) {
    let columnsExt = createColumnsIntermediate(columnsAdded,isFinish);
    return (
        [
            ColumnIntermediateRankOws({ status:isFinish }),
            ColumnBib({ label: "HeaderBibNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ...columnsExt
        ]
    )
}

export function TableColumnsOfficialSM(isFinish) {
    return (
        [
            ColumnIntermediateRankOws({ status:isFinish, disableSort:true }),
            ColumnNoc({}),
            ColumnName({ disableSort:true }),
            ColumnIntermediateTimeDiffOws({ status:isFinish, label: 'HeaderFinish'}),
        ]
    )
}
